<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Nueva empresa</span>
      <button
        mat-icon-button
        (click)="matDialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>

    <mat-toolbar-row
      class="toolbar-bottom py-16"
      fxLayout="column"
      fxLayoutAlign="center center">
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
    <form [formGroup]="contactForm">
      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Razón social</mat-label>
          <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
          <input
            name="businessName"
            formControlName="businessName"
            matInput
            required />
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>CUIT</mat-label>
          <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
          <input name="cuit" formControlName="cuit" matInput />
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Domicilio</mat-label>
          <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
          <input name="adress" formControlName="adress" matInput />
        </mat-form-field>
      </div>
    </form>
  </div>

  <div
    mat-dialog-actions
    class="m-0 p-16"
    fxLayout="row"
    fxLayoutAlign="center center">
    <button
      *ngIf="action === 'edit'"
      mat-raised-button
      class="mr-8"
      (click)="matDialogRef.close(['delete', contactForm])"
      aria-label="Delete"
      matTooltip="Delete"
      style="background-color: #2d323e; color: white">
      {{ 'CANCEL' | translate }}
    </button>

    <button
      *ngIf="action === 'edit'"
      mat-raised-button
      class="submit-button"
      color="accent"
      class="save-button"
      (click)="onCreateNewBusiness()"
      [disabled]="contactForm.invalid"
      aria-label="SAVE">
      {{ 'SAVE' | translate }}
    </button>
  </div>
</div>
